import StorageService from '../services/storage.service';

export function getLanguage() {
    const LanguageList = ['en', 'ko', 'ja', 'id', 'in', 'zh'];
    const localLanguage = () => {
        const agent = navigator.userAgent.toLowerCase();
        if (agent.indexOf('msie') > -1 || agent.indexOf('trident') > -1)
            return navigator.userLanguage.split('-')[0]; //ie
        else return navigator.language.split('-')[0]; //order
    };
    return new StorageService().language.get()
        ? new StorageService().language.get()
        : LanguageList.includes(localLanguage())
        ? localLanguage() !== 'in'
            ? 'ko'
            : 'id'
        : 'ko';
}
